import React from "react";
import Modal from "./Modal";

export const ErrorPage = () => (

    <div>
        <Modal content={"Try checking your internet connection & reloading the page"} />
    </div>

)